// initial state
export const state = _ => ({
    resourceUrl: '',
    groups: [],
    formData: {},
    requiredFields: [],
    formStatus: false,
    errors: [],
    scrolled: false,
    origins: [],
    sortedParameters: [],
    globalExtra: {},
    isMobile: true,
})

export default state
